import Strings from '@/constants/String';

/**
 * Opens Razorpay for a UPI Autopay mandate.
 *
 * The subscribe route hands back `payload.checkout` already shaped for the SDK
 * — it carries `subscription_id`, not `order_id`, so it is passed through
 * verbatim rather than rebuilt. The venue does not move onto the subscription
 * when this closes; that happens on the `subscription.charged` webhook, so the
 * caller has to poll the venue's plan afterwards.
 */
export const openSubscriptionCheckout = (
  checkout: Record<string, any>,
  handlers: {
    onAuthorised?: (response: any) => void;
    onDismiss?: () => void;
    onFailed?: (response: any) => void;
  } = {},
) => {
  const Razorpay = (window as any).Razorpay;
  if (!Razorpay) {
    throw new Error('Razorpay checkout script is not loaded');
  }

  const rzp = new Razorpay({
    ...checkout,
    image: Strings.logoUrl,
    theme: { color: '#43b4b4' },
    handler: (response: any) => handlers.onAuthorised?.(response),
    modal: {
      ondismiss: () => handlers.onDismiss?.(),
    },
  });

  rzp.on('payment.failed', (response: any) => handlers.onFailed?.(response));
  rzp.open();
  return rzp;
};
